<template>
<div class="chapter">
<div class="inner_page">
<p class="textcenter"><a id="ch00_fm02_dedi"></a><a id="page_ii"></a>A<span class="small">LSO BY</span> B<span class="small">HARATI</span> M<span class="small">UKHERJEE</span></p>
<p class="textcenter"><em>Fiction</em></p>
<p class="textcenter"><span class="small">THE TIGER’S DAUGHTER<br/>WIFE<br/>DARKNESS</span></p>
<p class="textcenter"><em>Nonfiction</em></p>
<p class="textcenter"><span class="small">DAYS AND NIGHTS IN CALCUTTA<br/>THE SORROW AND THE TERROR</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm02_dedi.vue?e4ae0f62